/**
 * @author Harish.R <harish.r@314ecorp.com>
 * @description keycloakUser utils for widgets
 */
import _ from 'lodash';
import { findUserRole } from 'components/userManagement/UserBadge';

/**
 * get user full name
 */
const getUserFullName = (user: UserManagement.IUserResponseModel): string => {
	const { firstName, lastName, email, username } = user || {};
	return firstName && lastName ? `${firstName} ${lastName}` : email || username;
};

/**
 * filterAssignedRoles
 */
const filterAssignedRoles = (roles: UserManagement.IUserRoleResponse[]): string[] => {
	return _.map(_.filter(roles, { assigned: true }), 'id');
};

/**
 * prepare roles widget model
 */
const prepareUserRoles = (
	availableRoles: UserManagement.IRoleResponse[],
	filteredRoleIDs: string[],
): UserManagement.IUserRoleResponse[] => {
	return _.map(availableRoles, (role) => ({
		...role,
		assigned: _.includes(filteredRoleIDs, role?.id),
	}));
};

/**
 * Add Provider Info form model
 */
const prepareUserFormModel = (
	isAddForm: boolean,
	availableRoles: UserManagement.IRoleResponse[],
	user?: UserManagement.IUserResponseModel,
): UserManagement.IFormModel => {
	const userRoles = user?.roles ?? [];
	const prioritizedRoles = _.filter(userRoles, (role) => role?.name === findUserRole(userRoles));
	const filteredRoleIDs = filterAssignedRoles(prioritizedRoles);
	const roles = prepareUserRoles(availableRoles, filteredRoleIDs);

	let attributes = {
		username: '',
		email: '',
		firstName: '',
		lastName: '',
		enabled: true,
		roles,
	} as UserManagement.IFormModel;
	if (isAddForm) {
		attributes = { ...attributes, temppassword: '' };
	}

	return _.mapValues(attributes, (defaultValue, key) => {
		if (key === 'roles') {
			return roles;
		}
		return _.get(user, key, defaultValue);
	}) as UserManagement.IFormModel;
};

export { getUserFullName, prepareUserFormModel, prepareUserRoles, filterAssignedRoles };
